import { Input, Textarea } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import type { UseFormReturn } from 'react-hook-form';
import { SENDER_LIMITS, type SenderFormValues } from './sender.ts';

export const SenderFields = ({ form }: { form: UseFormReturn<SenderFormValues> }) => {
  const { t } = useTranslation();
  const { errors } = form.formState;
  const required = t('sender.fieldRequired');
  return (
    <>
      <Input
        label={t('sender.name')}
        required
        autoComplete="organization"
        maxLength={SENDER_LIMITS.name}
        errorText={errors.name ? required : undefined}
        {...form.register('name')}
      />
      <Input
        label={t('sender.phone')}
        required
        type="tel"
        autoComplete="tel"
        maxLength={SENDER_LIMITS.phone}
        errorText={errors.phone ? required : undefined}
        {...form.register('phone')}
      />
      <Textarea
        label={t('sender.address')}
        required
        rows={3}
        maxLength={SENDER_LIMITS.address}
        errorText={errors.address ? required : undefined}
        {...form.register('address')}
      />
      <Input
        label={t('sender.taxId')}
        helperText={t('sender.taxIdHelp')}
        autoComplete="off"
        maxLength={SENDER_LIMITS.taxId}
        {...form.register('taxId')}
      />
    </>
  );
};
